import React from 'react';

import * as ST from './styled';

interface IBaseProps {
    value?: number,
    min?: number,
    onChangeCount?: (value: number) => void,
    className?: string,
}

interface ICounterMaxCount extends IBaseProps {
    isIncrementDisable?: boolean,
    max?: never,
}

interface ICounterMax extends IBaseProps {
    isIncrementDisable?: never,
    max?: number,
}
export type ICounterProps = ICounterMaxCount | ICounterMax;

/**
 * Счетчик +/-
 * @param isIncrementDisable - блокируется увеличение счетчика
 * @param max - максимально возможное количество, при котором блокируется увеличение счетчика
 */
export const IncrementDecrementCounter = ({ value, max = 9, min = 1, isIncrementDisable, onChangeCount, className }: ICounterProps): JSX.Element => {
    const isMinimum = value === min;
    const isMaximum = value === max;

    if (!value || !onChangeCount) {
        return <></>;
    }

    return (
        <ST.IncrementDecrementCounter className={className}>
            <ST.Btn
                src={'/static/images/icons/minus-mini.svg'}
                alt='уменьшить'
                onClick={isMinimum ? () => null : () => onChangeCount(-1)}
                isHide={isMinimum}
                data-test='decrement'
            />
            <ST.CountValue
                data-test='value'
            >
                {value}
            </ST.CountValue>
            <ST.Btn
                src={'/static/images/icons/plus-mini.svg'}
                alt='увеличить'
                onClick={isIncrementDisable || isMaximum ? () => null : () => onChangeCount(1)}
                isHide={isIncrementDisable || isMaximum}
                data-test='increment'
            />
        </ST.IncrementDecrementCounter>
    );
};
